import { useCallback } from 'react'

import { getAuth, signInWithCustomToken } from 'firebase/auth'

import { type OnrApiMutationOptions, useOnrApi } from '../api/mutation/useOnrApi.ts'

export interface PiloteSignInRequest {
  readonly session: string
  readonly storeToken?: boolean
}

export const usePiloteSignIn = (options?: OnrApiMutationOptions<string, PiloteSignInRequest>) => {
  const { mutateAsync, isPending } = useOnrApi<string, PiloteSignInRequest>({ type: 'piloteSignIn', ...options })
  const signIn = useCallback(
    async (loginRequest: PiloteSignInRequest) => {
      try {
        const customToken = await mutateAsync(loginRequest)
        return await signInWithCustomToken(getAuth(), customToken)
      } catch {
        return null
      }
    },
    [mutateAsync]
  )
  return { signIn, isPending }
}
